export default{sources:{avif:"__VITE_ASSET__CJ9lOhXf__ 400w",webp:"__VITE_ASSET__ClYaptsa__ 400w"},img:{src:"__VITE_ASSET__DsO4L0q6__",w:400,h:600}};